import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getSubcategoryAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/subcategory', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getSubcategoryById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/subcategory/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createSubcategory = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/subcategory`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateSubcategory = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/subcategory/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteSubcategory = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/subcategory/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteSubcategory = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/subcategory/${id}`);
    return handleResponse(response, onSuccess, onError);
};